import AsyncStorage from '@react-native-async-storage/async-storage';

/**
 * «Удалить только у себя» also clears the visible history for me: we remember a
 * per-conversation «cleared at» timestamp and the thread shows only messages
 * sent AFTER it. Local + persistent; doesn't touch the channel for others.
 * Keyed by `${entityType}:${entityId}`.
 */
const KEY = 'chat_cleared_at';
let cache: Record<string, number> = {};
let loaded = false;

/** Load persisted cleared-at timestamps into memory (call once early). */
export async function loadClearedChats(): Promise<void> {
  if (loaded) return;
  loaded = true;
  try {
    const raw = await AsyncStorage.getItem(KEY);
    if (raw) cache = JSON.parse(raw);
  } catch {
    /* first run / parse error — empty */
  }
}

/** Cleared-before timestamp (ms) for a conversation, or 0 if never cleared. */
export function getClearedAt(key: string): number {
  return cache[key] || 0;
}

/** Set the cleared-before timestamp and persist. */
export async function setClearedAt(key: string, ts: number): Promise<void> {
  cache[key] = ts;
  try {
    await AsyncStorage.setItem(KEY, JSON.stringify(cache));
  } catch {
    /* persistence best-effort */
  }
}
